/**
 *
 * AppLayout
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'antd';
import Header from '../Header/Header';
import { Sidebar } from '../Sidebar/Sidebar';

interface IProps {}

export const AppLayout: React.FC<IProps> = props => {
  return (
    <LayoutWrapper>
      <Layout>
        <Sidebar />
        <Layout>
          <Header />
          <Layout.Content>{React.Children.only(props.children)}</Layout.Content>
        </Layout>
      </Layout>
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;
